import { SVGS } from '@zonofi/zono-money-design-system';
import { InvoiceStatusEnum } from '@zonofi/zono-money-store';

export const getInvoiceStatusStyle = (status: InvoiceStatusEnum) => {
  switch (status) {
    case InvoiceStatusEnum.PAYMENT_PENDING:
      return {
        backgroundClass: 'status-pending-bg',
        textClass: 'status-pending-text',
      };
    case InvoiceStatusEnum.PARTIALLY_PAID:
      return {
        backgroundClass: 'status-partially-paid-bg',
        textClass: 'status-partially-paid-text',
      };
    case InvoiceStatusEnum.PAID:
      return {
        backgroundClass: 'status-approved-bg',
        textClass: 'status-approved-text',
      };
    case InvoiceStatusEnum.CANCELLED:
      return {
        backgroundClass: 'status-cancelled-bg',
        textClass: 'status-cancelled-text',
      };
    case InvoiceStatusEnum.OVER_DUE:
      return {
        backgroundClass: 'status-over-due-bg',
        textClass: 'status-over-due-text',
      };
    default:
      return {
        backgroundClass: 'status-pending-bg',
        textClass: 'status-pending-text',
      };
  }
};

export const getInvoiceIcon = (status: InvoiceStatusEnum): string => {
  switch (status) {
    case InvoiceStatusEnum.PAID:
      return SVGS.InvoicePaid;
    case InvoiceStatusEnum.PARTIALLY_PAID:
      return SVGS.InvoicePartiallyPaid;
    default:
      return SVGS.InvoicePartiallyPaid;
  }
};
